module.exports = ":host button {\n  background-color: transparent;\n  font-size: 1.125rem;\n  color: rgba(255, 255, 255, 0.8);\n  line-height: 2.25rem;\n  letter-spacing: -0.1px; }\n  :host button .usefullink-item-container {\n    display: block !important; }\n  :host button:hover {\n    color: #fff; }\n  @media (max-width: 1024px) {\n    :host button {\n      font-size: 1rem; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/useful-link-item/useful-link-item.component.scss
// module id = ./src/app/shared/components/useful-link-item/useful-link-item.component.scss
// module chunks = main